<template>
  <v-container fluid class="pa-0 pt-2">
    <v-row>
      <!-- Other Information Card -->
      <v-col cols="12" md="6">
        <v-card outlined elevation="0" class="mb-4 h-100">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="blue darken-2" small
                >mdi-information-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
              >
                Other Information
              </h3>
            </div>
          </div>
          <v-card-text class="pa-4 font-size-16">
            <table width="100%">
              <tr
                v-for="(field, index) in tOneFields"
                :key="'tOneFields' + index"
              >
                <td
                  style="width: 170px"
                  valign="top"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  {{ field.title }}
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="dataLoading">
                    <v-skeleton-loader
                      class="custom-skeleton width-80"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <template v-if="field.child && detail[field.key]">
                      {{ detail[field.key][field.child] }}
                    </template>
                    <template v-else-if="detail[field.key]">
                      <template
                        v-if="
                          field.key == 'end_life' ||
                          field.key == 'activation_date' ||
                          field.key == 'installation_date'
                        "
                      >
                        {{ formatDate(detail[field.key]) }}
                      </template>
                      <template v-else-if="field.key == 'serial_no'">
                        <v-chip
                          color="cyan"
                          label
                          small
                          text-color="white"
                          class="font-weight-600"
                        >
                          {{ detail[field.key] }}
                        </v-chip>
                      </template>
                      <template v-else-if="field.key == 'location'">
                        {{ detail[field.key].text }}
                      </template>
                      <template v-else-if="field.key == 'property'">
                        {{ detail[field.key].property_address }}
                      </template>
                      <template v-else-if="field.key == 'customer'">
                        {{ detail[field.key].company_name }}
                      </template>
                      <template v-else>
                        {{ detail[field.key] }}
                      </template>
                    </template>
                    <template v-else>
                      <em class="text-muted">No {{ field.title }}</em>
                    </template>
                  </template>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Warranty Information Card -->
      <v-col
        cols="12"
        md="6"
        v-if="
          detail &&
          detail.has_warranty == 1 &&
          detail.warranty &&
          detail.warranty.start_date
        "
      >
        <v-card outlined elevation="0" class="mb-4 h-100">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="cyan darken-2" small
                >mdi-shield-check-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase mr-2"
              >
                Warranty Information
              </h3>
            </div>
            <template
              v-if="detail && detail.warranty && detail.warranty.status"
            >
              <v-chip
                small
                label
                text-color="white"
                class="font-weight-600"
                :color="getStatusColor(detail.warranty.status)"
                v-if="detail.warranty.status"
              >
                {{ getStatusText(detail.warranty.status) }}
              </v-chip>
            </template>
          </div>
          <v-card-text class="pa-4 font-size-16">
            <table width="100%">
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Warranty #
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-600 border-bottom-dashed"
                >
                  <template
                    v-if="
                      detail && detail.warranty && detail.warranty.unique_id
                    "
                  >
                    <Barcode
                      route="warranty.detail"
                      :barcode="detail.warranty.unique_id"
                      :id="detail.warranty.id"
                    >
                    </Barcode>
                  </template>
                  <template v-else>
                    <em class="text-muted">no serial no</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Start Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-600 border-bottom-dashed"
                >
                  <template
                    v-if="
                      detail && detail.warranty && detail.warranty.start_date
                    "
                  >
                    <v-chip
                      outlined
                      label
                      small
                      color="green"
                      class="font-weight-600"
                    >
                      {{ formatDate(detail.warranty.start_date) }}
                    </v-chip>
                  </template>
                  <template v-else>
                    <em class="text-muted">no start date</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  End Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-600 border-bottom-dashed"
                >
                  <template
                    v-if="detail && detail.warranty && detail.warranty.end_date"
                  >
                    <v-chip
                      outlined
                      class="mr-2 font-weight-600"
                      label
                      small
                      color="blue"
                    >
                      {{ formatDate(detail.warranty.end_date) }}
                    </v-chip>
                    <span
                      class="blue--text font-weight-700 text-nowrap py-1 d-inline-block"
                      v-if="totalDays(detail.warranty.end_date) > 0"
                    >
                      ( {{ totalDays(detail.warranty.end_date) }} Days )
                    </span>
                  </template>
                  <template v-else>
                    <em class="text-muted">no End date</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500"
                >
                  Cost
                </td>
                <td valign="middle" class="py-1 font-size-18 font-weight-600">
                  <template
                    v-if="detail && detail.warranty && detail.warranty.cost"
                  >
                    <v-chip
                      outlined
                      label
                      small
                      color="blue"
                      class="font-weight-600"
                    >
                      {{ formatMoney(detail.warranty.cost) }}
                    </v-chip>
                  </template>
                  <template v-else>
                    {{ detail.pm_one_serial_number }}
                  </template>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Delivery Info Card -->
      <v-col cols="12" md="6">
        <v-card outlined elevation="0" class="mb-4 h-100">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="green darken-2" small
                >mdi-truck-delivery-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
              >
                Delivery Info
              </h3>
            </div>
          </div>
          <v-card-text class="pa-4 font-size-16">
            <table width="100%">
              <tr>
                <td
                  style="width: 210px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Do No.
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.do_no">
                    {{ detail.do_no }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no Do No. </em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 210px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Commission Certificate No.
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.common_cert_no">
                    {{ detail.common_cert_no }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no Commission Certificate No.</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 210px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Arrival Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.arrival_date">
                    {{ formatDate(detail.arrival_date) }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no arrival date</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 210px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Delivery Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.delivery_date">
                    {{ formatDate(detail.delivery_date) }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no Delivery Date</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 210px"
                  valign="top"
                  class="py-1 font-size-18 font-weight-500"
                >
                  Delivery Remark
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <template v-if="detail && detail.delivery_remark">
                    {{ detail.delivery_remark }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no Delivery Remark</em>
                  </template>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Tool Purchase Information Card -->
      <v-col cols="12" md="6">
        <v-card outlined elevation="0" class="mb-4 h-100">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="purple darken-2" small
                >mdi-cart-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
              >
                Asset Purchase Information
              </h3>
            </div>
          </div>
          <v-card-text class="pa-4 font-size-16">
            <table width="100%">
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Sales Person
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.salesperson">
                    {{ detail.salesperson }}
                  </template>
                  <em class="text-muted" v-else> no sales person </em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Supplier
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template
                    v-if="
                      detail && detail.supplier && detail.supplier.display_name
                    "
                  >
                    {{ detail.supplier.display_name }}
                  </template>
                  <em class="text-muted" v-else> no supplier </em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Purchase Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.purchase_date">
                    {{ formatDate(detail.purchase_date) }}
                  </template>
                  <em class="text-muted" v-else> no purchased date </em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Purchase Price
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.purchase_price">
                    <v-chip
                      outlined
                      label
                      small
                      color="blue"
                      class="font-weight-600"
                    >
                      {{ formatMoney(detail.purchase_price) }}
                    </v-chip>
                  </template>
                  <em v-else class="text-muted"> no Purchase Price</em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Quotation No.
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.quotation_no">
                    {{ detail.quotation_no }}
                  </template>
                  <em v-else class="text-muted"> no quotation no.</em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500"
                >
                  Invoice No.
                </td>
                <td valign="middle" class="py-1 font-weight-600 font-size-18">
                  <template v-if="detail && detail.invoice_no">
                    {{ detail.invoice_no }}
                  </template>
                  <em v-else class="text-muted"> no invoice no.</em>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Preventive Maintenance Information Card -->
      <v-col
        cols="12"
        md="6"
        v-if="
          detail &&
          detail.has_preventive_maintanance == 1 &&
          detail.preventive_maintanance &&
          detail.preventive_maintanance.start_date
        "
      >
        <v-card outlined elevation="0" class="mb-4 h-100">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="orange darken-2" small
                >mdi-wrench-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
              >
                Preventive Maintenance Information
              </h3>
            </div>
          </div>
          <v-card-text class="pa-4 font-size-16">
            <table width="100%">
              <tr>
                <td
                  style="width: 220px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Preventive Maintenance #
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template
                    v-if="
                      detail &&
                      detail.preventive_maintanance &&
                      detail.preventive_maintanance.unique_id
                    "
                  >
                    <Barcode
                      route="preventive-maintanance.detail"
                      :barcode="detail.preventive_maintanance.unique_id"
                      :id="detail.preventive_maintanance.id"
                    >
                    </Barcode>
                  </template>
                  <template v-else>
                    <em class="text-muted">no serial no</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 220px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Start Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template
                    v-if="
                      detail &&
                      detail.preventive_maintanance &&
                      detail.preventive_maintanance.start_date
                    "
                  >
                    <v-chip
                      outlined
                      label
                      small
                      color="green"
                      class="font-weight-600"
                    >
                      {{ formatDate(detail.preventive_maintanance.start_date) }}
                    </v-chip>
                  </template>
                  <template v-else>
                    <em class="text-muted">no start date</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 220px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  End Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template
                    v-if="
                      detail &&
                      detail.preventive_maintanance &&
                      detail.preventive_maintanance.end_date
                    "
                  >
                    <v-chip
                      outlined
                      class="mr-2 font-weight-600"
                      label
                      small
                      color="red"
                    >
                      {{ formatDate(detail.preventive_maintanance.end_date) }}
                    </v-chip>
                  </template>
                  <template v-else>
                    <em class="text-muted">no End date</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 220px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Maintenance Cost
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template
                    v-if="
                      detail &&
                      detail.preventive_maintanance &&
                      detail.preventive_maintanance.cost
                    "
                  >
                    <v-chip
                      outlined
                      label
                      small
                      color="blue"
                      class="font-weight-600"
                    >
                      {{ formatMoney(detail.preventive_maintanance.cost) }}
                    </v-chip>
                  </template>
                  <template v-else>
                    {{ detail.pm_one_serial_number }}
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 220px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500"
                >
                  Status
                </td>
                <td valign="middle" class="py-1 font-weight-600 font-size-18">
                  <template
                    v-if="
                      detail &&
                      detail.preventive_maintanance &&
                      detail.preventive_maintanance.status
                    "
                  >
                    <v-chip
                      small
                      label
                      text-color="white"
                      class="font-weight-600"
                      :color="
                        getStatusColor(detail.preventive_maintanance.status)
                      "
                      v-if="detail.preventive_maintanance.status"
                    >
                      {{ getStatusText(detail.preventive_maintanance.status) }}
                    </v-chip>
                  </template>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Optional Faulty/Retired Template -->
      <template
        v-if="
          detail.faulty ||
          detail.retired ||
          (detail.has_warranty == 1 &&
            detail.warranty &&
            detail.warranty.start_date)
        "
      >
        <v-col cols="12" md="6" v-if="false && detail.is_purchase_info == 1">
          <v-card outlined elevation="0" class="mb-4 h-100">
            <div
              class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
            >
              <div class="d-flex align-center">
                <v-icon class="mr-2" color="purple darken-2" small
                  >mdi-cart-outline</v-icon
                >
                <h3
                  class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
                >
                  Purchased Information
                </h3>
              </div>
            </div>
            <v-card-text class="pa-4 font-size-16">
              <table width="100%">
                <tr>
                  <td
                    style="width: 220px"
                    class="font-size-18 font-weight-500 py-1 border-bottom-dashed"
                  >
                    Supplier
                  </td>
                  <td
                    class="font-weight-600 font-size-18 py-1 border-bottom-dashed"
                  >
                    <template
                      v-if="
                        detail &&
                        detail.supplier &&
                        detail.supplier.display_name
                      "
                    >
                      {{ detail.supplier.display_name }}
                    </template>
                    <em class="text-muted" v-else> no supplier </em>
                  </td>
                </tr>
                <tr>
                  <td
                    style="width: 220px"
                    class="font-size-18 font-weight-500 py-1 border-bottom-dashed"
                  >
                    Purchased On
                  </td>
                  <td
                    class="font-weight-600 font-size-18 py-1 border-bottom-dashed"
                  >
                    <template v-if="detail && detail.purchased_on">
                      {{ formatDate(detail.purchased_on) }}
                    </template>
                    <em class="text-muted" v-else> no purchased date </em>
                  </td>
                </tr>
                <tr>
                  <td
                    style="width: 220px"
                    class="font-size-18 font-weight-500 py-1"
                  >
                    Cost Price
                  </td>
                  <td class="font-weight-600 font-size-18 py-1">
                    <template v-if="detail && detail.cost_price">
                      {{ formatMoney(detail.cost_price) }}
                    </template>
                    <em v-else class="text-muted"> no cost price</em>
                  </td>
                </tr>
              </table>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6" v-if="false">
          <v-card outlined elevation="0" class="mb-4 h-100">
            <div
              class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
            >
              <div class="d-flex align-center">
                <v-icon class="mr-2" color="red darken-2" small
                  >mdi-alert-circle-outline</v-icon
                >
                <h3
                  class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
                  v-if="detail.faulty"
                >
                  Faulty Remark
                </h3>
                <h3
                  class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
                  v-if="detail.retired"
                >
                  Retired Remark
                </h3>
              </div>
            </div>
            <v-card-text class="pa-4 font-size-16">
              <div class="font-weight-600 font-size-18">
                <template v-if="detail && detail.faulty">
                  <span>{{ detail.faulty_remark }}</span>
                </template>
                <template v-else-if="detail && detail.retired">
                  <span>{{ detail.retired_remark }}</span>
                </template>
                <em class="text-muted" v-else> no remark </em>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import Barcode from "@/view/pages/partials/Barcode.vue";
import { toSafeInteger } from "lodash";
/* import { QUERY } from "@/core/services/store/request.module"; */
import CommonMixin from "@/core/plugins/common-mixin";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [CommonMixin],
  data() {
    return {
      equipment: 0,
      dataLoading: true,
      chartOptions: {
        chart: {
          id: "equipment-summary",
        },
        xaxis: {
          categories: [],
        },
        dataLabels: {
          enabled: true,
          style: {
            fontFamily: "'Poppins', Helvetica, Arial, sans-serif",
          },
        },
      },
      series: [],
      tOneFields: [
        {
          title: "Specification",
          key: "specification",
          child: false,
        },
        {
          title: "Brand",
          key: "brand",
          child: false,
        },
        // {
        //   title: "Model",
        //   key: "model",
        //   child: false,
        // },
        {
          title: "Category",
          key: "category",
          child: false,
        },
        {
          title: "Sub-Location",
          key: "location",
          child: false,
        },
        {
          title: "Description",
          key: "description",
          child: false,
        },
      ],
    };
  },
  props: {
    detail: {
      type: Object,
      required: true,
      default: () => {
        return new Object();
      },
    },
  },
  watch: {
    detail: {
      deep: true,
      immediate: true,
      handler(param) {
        this.equipment = this.lodash.toSafeInteger(param.id);
        this.dataLoading = false;
      },
    },
  },
  methods: {
    getProfileImage() {
      if (!this.detail.image) {
        return null;
      }
      return this.detail.image;
    },
    /*   totalDays(end_date) {
      var a = moment(end_date, "yyyy-MM-DD");
      var b = moment();
      var final = a.diff(b, "days");
      return final;
    }, */
    totalDays(end_date) {
      let today = moment().format("YYYY-MM-DD");

      var a = moment(end_date);
      var b = moment(today); //date.start_date
      var final = a.diff(b, "days"); // =1
      if (final <= 0) {
        final = 0;
      }
      return final;
    },
    totalDaysEndLife(end_date) {
      var a = moment(end_date, "yyyy-MM-DD").add(1, "days");
      var b = moment();
      var final = a.diff(b, "days");
      return final;
    },
    getStatusText(data) {
      if (toSafeInteger(data) == 1) {
        return "Draft";
      } else if (toSafeInteger(data) == 2) {
        return "Active";
      } else if (toSafeInteger(data) == 3) {
        return "Extended";
      } else if (toSafeInteger(data) == 4) {
        return "Terminated";
      } else if (toSafeInteger(data) == 5) {
        return "Expired";
      }
    },
    getFormattedProperty(row) {
      let tempArr = [];
      if (row.unit_no) {
        tempArr.push(row.unit_no);
      }
      if (row.street_1) {
        tempArr.push(row.street_1);
      }
      if (row.street_2) {
        tempArr.push(row.street_2);
      }

      if (row.country) {
        tempArr.push(row.country);
      }
      return tempArr.join(", ");
    },
    getFormattedCompany() {
      let tempArr = [];
      if (this.detail.entity.unit_no) {
        tempArr.push(this.detail.entity.unit_no);
      }
      if (this.detail.entity.street_1) {
        tempArr.push(this.detail.entity.street_1);
      }
      if (this.detail.entity.street_2) {
        tempArr.push(this.detail.entity.street_2);
      }

      if (this.detail.entity.zip_code) {
        tempArr.push(this.detail.entity.zip_code);
      }
      if (this.detail.entity.landmark) {
        tempArr.push(this.detail.entity.landmark);
      } else {
        tempArr.push("Singapore");
      }
      /*   if (this.lodash.isEmpty(row.city) === false) {
        tempArr.push(row.city.name);
      }
      if (this.lodash.isEmpty(row.state) === false) {
        tempArr.push(row.state.name);
      }
      if (this.lodash.isEmpty(row.country) === false) {
        tempArr.push(row.country);
      } */
      return tempArr.join(", ");
    },
    getStatusColor(data) {
      if (toSafeInteger(data) == 1) {
        return "blue";
      } else if (toSafeInteger(data) == 2) {
        return "green";
      } else if (toSafeInteger(data) == 3) {
        return "orange";
      } else if (toSafeInteger(data) == 4) {
        return "red";
      } else if (toSafeInteger(data) == 5) {
        return "teal";
      }
    },
  },
  mounted() {
    /*  this.getSummary(); */
  },
  computed: {
    equipmentActivated() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.detail) === false) {
        return _this.detail.activated == 1 ? true : false;
      }
      return false;
    },
  },
  components: {
    Barcode,
  },
};
</script>
